import { render, staticRenderFns } from "./GSelectInstrutor.vue?vue&type=template&id=0ab8bce3"
import script from "./GSelectInstrutor.vue?vue&type=script&lang=js"
export * from "./GSelectInstrutor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports